import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import Popup from "reactjs-popup";
import InfoUser from "../../components/Profile/InfoUser.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import { apiGetRequestHistory } from "../../services/api.service.js";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const REQUEST_STATUS = { no_process: "Chờ xử lý", approved: "Thành công", removed: "Từ chối" };
const REQUEST_TYPES = {
  full_name: "Thay đổi họ và tên",
  phone_number: "Thay đổi số điện thoại",
  email: "Thay đổi email",
  bank: "Thay đổi tài khoản ngân hàng",
  birthday: "Thay đổi ngày sinh",
  forget_password: "Cấp lại mật khẩu đăng nhập",
  forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  confirm_account: "Xác minh tài khoản",
};

// màu badge trạng thái xử lý
const STATUS_CLASS = {
  no_process: "bg-orange-100 text-orange-600 border-orange-300",
  approved: "bg-green-100 text-green-700 border-green-300",
  removed: "bg-red-100 text-red-600 border-red-300",
};
// màu trạng thái xác thực email / SMS
const VERIFICATION_CLASS = {
  success: "text-green-700",
  invalid: "text-red-600",
  not_received: "text-orange-600",
};

// các nút chức năng: id = loại yêu cầu
const CHANGE_BUTTONS = [
  { id: "full_name", img: "/button/btn-name.png", alt: "icon-user" },
  { id: "bank", img: "/button/btn-bank.png", alt: "icon-bank" },
  { id: "email", img: "/button/btn-mail.png", alt: "icon-mail" },
  { id: "phone_number", img: "/button/btn-phone.png", alt: "icon-phone" },
  { id: "confirm_account", img: "/button/btn-account.png", alt: "icon-account" },
  { id: "forget_password", img: "/button/btn-pass.png", alt: "icon-pass" },
];

const verificationText = (status, sendType) => {
  if (status === "success") return "Đã nhận xác thực hợp lệ";
  if (status === "invalid") return sendType === "email" ? "Xác thực sai địa chỉ email" : "Xác thực sai số điện thoại";
  return sendType === "email" ? "Chưa nhận email xác thực" : "Chưa nhận SMS xác thực";
};

// che mã yêu cầu trong danh sách, vd: xxxxxx78
const maskCode = (code = "") => String(code).startsWith("xxxxxx") ? String(code) : `xxxxxx${String(code).slice(-2)}`;

function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [historyCollapsed, setHistoryCollapsed] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const recentRequests = (data?.recent_requests || []).slice(0, 2);
  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];

  useEffect(() => {
    if (!userName) navigate("/");
  }, [navigate, userName]);

  const changeInfo = async (typeModal) => {
    if (!userName) {
      return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
    } else {
      navigate("/change-info", { state: { userName, data, webSetting, typeModal } });
    }
  };

  // tra cứu yêu cầu bằng mã yêu cầu 8 số
  const checkRequestHistory = async () => {
    if (!/^\d{8}$/.test(requestCode)) {
      setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
      return;
    }
    setRequestHistoryError("");
    const result = await apiGetRequestHistory(userName, requestCode);
    if (result?.code === 200 && result?.data?.request) {
      setRequestHistory(result.data.request);
      setOpenRequestHistoryResult(true);
    } else {
      setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
    }
  };

  return (
    <motion.div
      initial={{ x: "100vw", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: "-100vw", opacity: 0 }}
      transition={{ type: "spring", stiffness: 1000, damping: 20, duration: 10 }}
      className="overflow-x-hidden p-5"
    >
      <div className="relative w-full rounded-[15px] border-[1.5px] border-[#FEF1E9] bg-gradient-to-b from-white to-[#FFEBDD] shadow-[0_0_0_2px_rgba(255,228,207,0.30),0_8px_32px_8px_rgba(242,113,33,0.08),0_4px_16px_4px_rgba(0,0,0,0.04)] tracking-wide flex flex-col justify-start items-center gap-2 pt-0 p-5">
        {/* Header với logo */}
        <div className="w-full h-fit flex justify-center items-center ">
          <img
            src="/search/title-sup-cskh.png"
            alt="logo"
            className="w-full max-w-[300px] h-auto object-contain"
          />
        </div>

        {/* Tiêu đề */}
        {/* <p className="w-full text-[#F27121] text-center text-[20px] font-bold leading-[28px] uppercase tracking-wide">
          THÔNG TIN CÁ NHÂN
        </p> */}

        {/* Container thông tin người dùng */}
        {/* <div className="w-full rounded-[20px] border border-[#DCDFE3] bg-[rgba(255,255,255,0.70)] shadow-[-42px_103px_31px_0_rgba(145,145,145,0.00),-27px_66px_29px_0_rgba(145,145,145,0.01),-15px_37px_24px_0_rgba(145,145,145,0.03),-7px_17px_18px_0_rgba(145,145,145,0.04),-2px_4px_10px_0_rgba(145,145,145,0.05)]">
          <InfoUser />
        </div> */}

        {/* Lịch sử yêu cầu */}
        <div className="w-full rounded-[16px] border border-[#DCDFE3] bg-[rgba(255,255,255,0.70)] p-3 mt-1">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1.5 relative">
              <button
                type="button"
                className="text-[#F27121] text-[14px] sm:text-[15px] font-bold uppercase cursor-pointer bg-transparent border-none p-0"
                onClick={() => setHistoryCollapsed((value) => !value)}
              >
                {historyCollapsed ? "▸" : "▾"} Kiểm tra lịch sử yêu cầu
              </button>
              <span
                className="relative"
                onMouseEnter={() => setShowRequestHistoryHelp(true)}
                onMouseLeave={() => setShowRequestHistoryHelp(false)}
              >
                <button
                  type="button"
                  aria-label="Thông tin lịch sử yêu cầu"
                  onClick={() => setShowRequestHistoryHelp((value) => !value)}
                  className="w-5 h-5 rounded-full bg-[#F27121] text-white text-[12px] font-bold leading-5 cursor-pointer border-none p-0"
                >
                  !
                </button>
                {showRequestHistoryHelp && (
                  <span className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1000] w-[min(320px,calc(100vw-32px))] p-4 rounded-[10px] bg-[#333333] text-white text-[13px] leading-normal text-left shadow-[0_12px_35px_rgba(0,0,0,0.35)]">
                    Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.
                  </span>
                )}
              </span>
            </div>
            <strong className="text-[13px] text-[#2F3945] truncate">{userName}</strong>
          </div>

          {!historyCollapsed && (
            <>
              <div className="flex flex-col gap-1.5 mt-2">
                {recentRequests.length === 0 && (
                  <p className="text-[12px] text-[#8e8e8e] italic m-0">Chưa có yêu cầu gần đây.</p>
                )}
                {recentRequests.map((request, index) => (
                  <div key={`${request.request_code}-${index}`} className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1 rounded-[8px] border border-[#F3E3D7] bg-white px-2.5 py-1.5">
                    <div className="flex items-center gap-2 min-w-0">
                      <strong className="text-[12px] sm:text-[13px] text-[#2F3945] truncate">{REQUEST_TYPES[request.update_type] || request.update_type}</strong>
                      <span className="text-[11px] sm:text-[12px] text-[#8e8e8e] whitespace-nowrap">Mã yêu cầu: {maskCode(request.request_code)}</span>
                    </div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className={`text-[11px] sm:text-[12px] font-semibold px-2 py-0.5 rounded-full border ${STATUS_CLASS[request.status] || "bg-gray-100 text-gray-600 border-gray-300"}`}>
                        {REQUEST_STATUS[request.status] || request.status}
                      </span>
                      {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && (
                        <span className={`text-[11px] sm:text-[12px] ${VERIFICATION_CLASS[request.verification_status || "not_received"]}`}>
                          {verificationText(request.verification_status || "not_received", request.send_type)}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex items-center gap-2 mt-2">
                <input
                  inputMode="numeric"
                  maxLength={8}
                  value={requestCode}
                  onChange={(event) => setRequestCode(event.target.value.replace(/\D/g, "").slice(0, 8))}
                  onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()}
                  placeholder="Nhập mã yêu cầu (8 số)"
                  className="min-w-0 flex-1 h-10 px-3 outline-none bg-white rounded-[7px] border border-[#F27121] text-sm font-medium text-[#F27121] placeholder:text-[#8e8e8e] placeholder:italic focus:ring-1 focus:ring-[#F27121]"
                />
                <button
                  type="button"
                  onClick={checkRequestHistory}
                  className="shrink-0 whitespace-nowrap h-10 px-4 rounded-[20px] text-white text-xs sm:text-sm font-semibold bg-gradient-to-r from-[#ff9f4d] to-[#F27121] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] transition-all duration-200 cursor-pointer border-none"
                >
                  Kiểm tra
                </button>
              </div>
              {requestHistoryError && <p className="text-red-500 text-sm mt-1 mb-0">{requestHistoryError}</p>}
            </>
          )}
        </div>
      </div>

      <div className="w-full grid grid-cols-2 justify-center items-center py-2 gap-2 mt-2 md:mt-5">
        {CHANGE_BUTTONS.map((item) => {
          // mục thông tin bị giới hạn: làm mờ, không cho bấm
          const disabled = disabledUpdateTypes.includes(item.id);
          return (
            <button
              key={item.id}
              disabled={disabled}
              className={disabled
                ? "flex items-center justify-center w-full overflow-hidden opacity-40 cursor-not-allowed"
                : "cursor-pointer flex items-center justify-center w-full overflow-hidden drop-shadow-[0_2px_4px_rgba(242,113,33,0.4)] hover:drop-shadow-[0_4px_8px_rgba(242,113,33,0.6)] transition-all duration-300 hover:scale-105 hover:opacity-90"}
              onClick={disabled ? undefined : () => changeInfo(item.id)}
            >
              <img src={item.img} alt={item.alt} className='w-full h-full object-cover pointer-events-none' />
            </button>
          );
        })}
      </div>

      {/* Popup kết quả tra cứu yêu cầu, căn giữa màn hình */}
      <Popup
        open={openRequestHistoryResult}
        onClose={() => setOpenRequestHistoryResult(false)}
        position="center"
        closeOnDocumentClick
        overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }}
        contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}
      >
        <div className="relative bg-white w-[92vw] max-w-[420px] rounded-xl p-4 sm:p-5 border border-[#FEF1E9] shadow-[0_4px_20px_rgba(0,0,0,0.15)]">
          <button
            type="button"
            className="absolute top-2 right-3 bg-transparent border-none cursor-pointer text-red-500 text-xl font-bold leading-none"
            onClick={() => setOpenRequestHistoryResult(false)}
          >
            ×
          </button>
          {requestHistory && (
            <div className="flex flex-col gap-1.5 text-[13px] sm:text-[14px] text-[#2F3945] text-left">
              <h3 className="text-[#F27121] text-center text-[16px] font-bold m-0 mb-1">KẾT QUẢ YÊU CẦU</h3>
              <p className="m-0"><strong>Loại yêu cầu:</strong> {REQUEST_TYPES[requestHistory.update_type] || requestHistory.update_type}</p>
              {(requestHistory.data_update?.content || requestHistory.content) && (
                <p className="m-0 break-words"><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update?.content || requestHistory.content}</p>
              )}
              <p className="m-0">
                <strong>Trạng thái:</strong>{" "}
                <span className={`text-[12px] font-semibold px-2 py-0.5 rounded-full border ${STATUS_CLASS[requestHistory.status] || ""}`}>
                  {REQUEST_STATUS[requestHistory.status] || requestHistory.status}
                </span>
              </p>
              {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && (
                <p className={`m-0 ${VERIFICATION_CLASS[requestHistory.verification_status || "not_received"]}`}>
                  {verificationText(requestHistory.verification_status || "not_received", requestHistory.send_type)}
                </p>
              )}
              {(requestHistory.note || requestHistory.result) && (
                <div><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>
              )}
              {(requestHistory.createdAt || requestHistory.created_at) && (
                <p className="m-0"><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt || requestHistory.created_at).toLocaleString("vi-VN")}</p>
              )}
            </div>
          )}
        </div>
      </Popup>
    </motion.div>
  );
}

export default Profile;
